<template>
  <button v-if="isSupported" @click="registerWithWebAuthn">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.33333,5.33333)"><path d="M5,28h38v14h-38z" fill="#3c9331"></path><path d="M14,40h-7v-7h2v5h5zM41,40h-7v-2h5v-5h2z" fill="#45de32"></path><path d="M41,13h-2v-5h-5v-2h7zM9,13h-2v-7h7v2h-5z" fill="#121212"></path><path d="M32.1,32.3c0.2,0.1 0.3,0.1 0.5,0.1c0.5,0 0.9,-0.3 1.2,-0.8c0.3,-0.6 0,-1.4 -0.7,-1.6c-0.3,-0.1 -0.5,-0.2 -0.7,-0.3h-4.6c1.1,0.9 2.5,1.8 4.3,2.6zM32.7,33.1v0c-0.1,0 -0.2,0 -0.3,0c-2.7,0 -5.1,-1.2 -6.9,-3.5h-3.1c2.3,3.8 5.9,6 10,6c0.1,0 0.2,0 0.3,0c0.7,0 1.2,-0.6 1.2,-1.3c0.1,-0.6 -0.5,-1.2 -1.2,-1.2zM27.4,35.6c-2.9,-1.3 -4.4,-2.4 -6.2,-4.9c-0.2,-0.3 -0.4,-0.7 -0.6,-1h-2.8c0.4,0.9 0.9,1.8 1.4,2.5c2,2.8 3.9,4.3 7.2,5.7c0.2,0.1 0.3,0.1 0.5,0.1c0.5,0 0.9,-0.3 1.2,-0.8c0.3,-0.6 0,-1.3 -0.7,-1.6z" fill="#60ff28"></path><path d="M13.3,22.9c-0.1,0 -0.1,0 0,0c-0.8,-0.1 -1.3,-0.7 -1.3,-1.4c0,-0.3 0.5,-6.4 5.3,-10c3.5,-2.5 7.2,-2.5 9,-2.5h0.3c0.7,0 1.3,0.6 1.3,1.3c0,0.7 -0.6,1.3 -1.3,1.3h-0.3c-1.6,0 -4.6,0 -7.4,2.1c-3.9,2.9 -4.3,8.1 -4.3,8.1c-0.1,0.6 -0.7,1.1 -1.3,1.1zM26.8,23c0,-0.7 -0.5,-1.3 -1.2,-1.3c-0.7,0 -1.3,0.5 -1.3,1.2c0,0.2 0,2.5 2.1,5.1h3.7c-3.2,-2.3 -3.3,-4.8 -3.3,-5z" fill="#4e3918"></path><path d="M34.3,26.4c-1.7,-0.9 -2.6,-2.7 -3.5,-4.4c-1.2,-2.4 -2.8,-5.6 -7,-3.8c-1.3,0.6 -2.3,1.6 -2.8,3c-0.9,2.3 -0.3,5 0.6,6.7c0,0.1 0.1,0.1 0.1,0.2h2.9c-0.2,-0.4 -0.5,-0.8 -0.7,-1.3c-0.8,-1.6 -1,-3.5 -0.5,-4.8c0.3,-0.8 0.8,-1.3 1.5,-1.6c1.8,-0.8 2.3,-0.2 3.7,2.7c0.8,1.7 1.8,3.6 3.7,5h2.7c0.2,-0.7 -0.1,-1.4 -0.7,-1.7z" fill="#4e3918"></path><path d="M19.9,28c-0.8,-2 -1.2,-4.4 -0.8,-6.5c0.4,-1.9 1.5,-3.3 3.2,-4.3c1.9,-1.1 3.6,-1.3 5.2,-0.7c2.9,1.1 4.9,4.8 6.1,7.7c0.3,0.6 1,1 1.6,0.7c0.6,-0.3 1,-1 0.7,-1.6c-1.3,-3.4 -3.7,-7.7 -7.5,-9.1c-2.3,-0.8 -4.7,-0.5 -7.2,0.9c-2.3,1.3 -3.9,3.3 -4.5,5.9c-0.5,2.3 -0.2,4.9 0.5,7.1h2.7z" fill="#4e3918"></path><path d="M5,28h38v2h-38z" fill="#d7347d"></path></g></g></svg>
  </button>
  <div class="alertF" v-else>
    مرورگر شما حسگر اثر انگشت را پشتیبانی نمیکند
  </div>
</template>
<script setup>
  import { ref , onMounted } from 'vue'
  import { preformatMakeCredReq,preformatMakeCredseq } from '@/utils/base64';
  import { useAlertStore } from '@/stores/alert'
  import { useUserStore } from '@/stores/user';
  const userStore = useUserStore()
  const alertStore = useAlertStore()
  const isSupported = ref(false)
  onMounted(() => {
    isSupported.value = window.PublicKeyCredential && typeof window.PublicKeyCredential === 'function'
  })
  async function registerWithWebAuthn() {
    const options = await userStore.fingerPrintRegisterRequest()
    if (!options || !options.publicKey) {
      alertStore.msg='مشکلی در دریافت challenge ثبت رخ داد.'
    }else{
      const res = preformatMakeCredReq(options.publicKey);
      const credential = await navigator.credentials.create({
        publicKey: res
      });
      const result = await userStore.fingerPrintRegisterResponse(preformatMakeCredseq(credential))
      if (result && result.status === 'success') {
        alertStore.type=true
        alertStore.msg='ثبت اثر انگشت موفقیت‌آمیز بود.'
      } else {
        alertStore.msg='ثبت اثر انگشت ناموفق بود.'
      }
    }
}
</script>
<style scoped>
  button{
    border: none;
    outline: none;
    width: 35px;
    height: 35px;
    cursor: pointer;
    padding: 0;
    background: transparent;
  }
  img{
    height: 100%;
    width: 100%;
  }
  .alertF{
    padding: 10px 15px;
    border-radius: 10px;
    background-color: red;
    color: white;
    text-align: center;
}
</style>